import { useState } from "react";

import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import ErrorPlaceholder from "common/components/ErrorPlaceholder";
import Loader from "common/components/Loader";
import SearchInput from "common/components/SearchInput";
import { Button } from "common/components/ui/Button";
import useWorkspaceProxies from "common/datahooks/useWorkspaceProxies";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import AddProxyButton from "./AddProxyButton";
import MobileList from "./MobileLayout/MobileList";
import ProxiesDesktopTable from "./ProxiesDesktopTable";

import EmptyStateImage from "assets/images/empty-placeholders/proxies.png";
import NoResultsImage from "assets/images/empty-placeholders/result-not-found.png";

export default function Proxies() {
  const isDesktop = useTwBreakpoint("lg");
  const [searchTerm, setSearchTerm] = useState("");

  const {
    isWorkspaceProxiesError,
    workspaceProxies,
    refetchWorkspaceProxies,
    isLoadingWorkspaceProxies,
  } = useWorkspaceProxies();

  if (isWorkspaceProxiesError) {
    return (
      <ErrorPlaceholder
        onRetry={refetchWorkspaceProxies}
        errorMessage="Could not display proxies"
      />
    );
  }
  if (isLoadingWorkspaceProxies) {
    return <Loader />;
  }
  if (!workspaceProxies?.length) {
    return (
      <EmptyPlaceholder
        imageSrc={EmptyStateImage}
        title="No custom proxies found"
        subtitle="You're currently using our secure proxy network. You can add your own proxies if you need a custom setup"
        actionComponent={<AddProxyButton size="md" />}
      />
    );
  }

  const filteredProxies = workspaceProxies.filter(({ name }) =>
    name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const Component = isDesktop ? ProxiesDesktopTable : MobileList;

  return (
    <>
      <SearchInput
        placeholder="Search proxies"
        value={searchTerm}
        className="lg:max-w-80"
        variant={isDesktop ? "sm" : "lg"}
        onChange={(e) => setSearchTerm(e.target.value)}
        onClear={() => setSearchTerm("")}
      />

      {filteredProxies.length ? (
        <Component proxies={filteredProxies} />
      ) : (
        <EmptyPlaceholder
          title="No custom proxies found"
          subtitle="No proxies match your search criteria. Try adjusting your search"
          imageSrc={NoResultsImage}
          actionComponent={
            <Button onClick={() => setSearchTerm("")}>Clear search</Button>
          }
        />
      )}
    </>
  );
}
